import { errorText } from "../utils/error-messages";

export const initReferenceInvite = () => {
  const referenceInvite = document.getElementById("reference-invite") as HTMLDivElement;

  if (!referenceInvite) {
    return;
  }
  const blockInviteByName = document.getElementById("block-invite-by-name") as HTMLDivElement;
  const blockGeneratedInvite = document.getElementById("block-generated-invite") as HTMLDivElement;

  const createInviteForm = blockInviteByName.querySelector(".create-invite-form") as HTMLDivElement;
  const buttonSubmit = createInviteForm.querySelector(".button-submit") as HTMLButtonElement;
  const buttonReset = blockGeneratedInvite.querySelector(".button-reset") as HTMLButtonElement;

  const inputUserId = blockInviteByName.querySelector(".user-id") as HTMLInputElement;
  const inputFirstName = blockInviteByName.querySelector(".first-name") as HTMLInputElement;

  const descriptionPreview = blockGeneratedInvite.querySelector(".description") as HTMLDivElement;
  const shareOnDevice = blockGeneratedInvite.querySelector(".share-on-device") as HTMLButtonElement;

  createInviteForm.addEventListener("submit", (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("first_name", inputFirstName.value);

    fetch(`/website-api/user/${inputUserId.value}/references/invite/`, {
      credentials: "same-origin",
      method: "post",
      body: formData,
    })
      .then((response) => response.json())
      .then((jsonResponse) => {
        if (jsonResponse.metadata.code !== 201) {
          if (jsonResponse.metadata.errors) {
            alert(jsonResponse.metadata.errors[0].error);

            restForm();

            return;
          }

          if (jsonResponse.metadata.error_message) {
            alert(jsonResponse.metadata.error_message);

            restForm();

            return;
          }

          alert(errorText("generic"));

          restForm();
        }
        const description = jsonResponse.data.description;
        const url = jsonResponse.data.url;

        descriptionPreview.textContent = `${description}\n${url}`;

        shareOnDevice.dataset.shareText = description;
        shareOnDevice.dataset.shareUrl = url;

        blockInviteByName.style.display = "none";
        blockGeneratedInvite.style.display = "block";
      });
  });

  buttonReset.addEventListener("click", () => {
    restForm();
  });

  function restForm() {
    inputFirstName.value = "";
    descriptionPreview.textContent = "";

    if (buttonSubmit) {
      const textContent = buttonSubmit.dataset.text ? buttonSubmit.dataset.text : null;
      buttonSubmit.disabled = false;
      buttonSubmit.textContent = textContent;
    }

    blockInviteByName.style.display = "block";
    blockGeneratedInvite.style.display = "none";
  }
};
